module.exports = __webpack_public_path__ + "static/media/bariatric-image1@2x.66f613e2.png";